import React from 'react';
import { SystemCheckItem, SystemCheckId } from '../types';
import { SystemCheckItemView } from './SystemCheckItem';

interface SystemCheckListProps {
  checks: SystemCheckItem[];
  onRetry?: (id: SystemCheckId) => void;
}

export const SystemCheckList: React.FC<SystemCheckListProps> = ({ checks, onRetry }) => {
  return (
    <div
      role="list"
      aria-live="polite"
      aria-label="Hardware and network system checks"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        maxHeight: '320px',
        overflowY: 'auto',
        paddingRight: '4px',
      }}
    >
      {checks.map((item) => (
        <SystemCheckItemView key={item.id} item={item} onRetry={onRetry} />
      ))}
    </div>
  );
};
